import React, { useEffect, useState } from 'react'
import useLanguages from '../hooks/useLanguages';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Checkbox, FormControlLabel, Tab, Tabs, TextField } from '@mui/material';
import { API, SERVER_DOMAIN } from '../assets/staticData';
import TextEditor from '../components/rich-text/TextEditor/TextEditor';
import { toast } from 'react-toastify';
import { Controller, useFieldArray, useForm } from 'react-hook-form';

const AnnouncementLanguageForm = ({
  control,
  index,
  onSubmit,
  handleSubmit,
}) => {

  const onSubmitHandler = (values) => {
    onSubmit(values, index)
  }

  return <div>
    <div style={{ margin: "10px 0" }}>
      <Controller
        name={`data.${index}.title`}
        control={control}
        render={({ field }) => (
          <TextField
            label="title"
            sx={{ width: 300, marginY: 1 }}
            {...field}
          />
        )}
      />
    </div>

    <div>
      <p style={{ fontSize: 15 }}>
        Content
      </p>

      <div style={{ margin: "10px 0" }}>
        <Controller
          name={`data.${index}.content`}
          control={control}
          render={({ field }) => (
            <TextEditor {...field} />
          )}
        />

      </div>
    </div>

    <Controller
      name={`data.${index}.isActive`}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              size="small"
            />
          }
          checked={field.value}
          onChange={(e) => field.onChange(e.target.checked)}
          label="Active"
          style={{ color: "gray" }}
        />
      )}
    />

    <button
      onClick={handleSubmit(onSubmitHandler)}
      className="bg-blue-500 w-2/5 flex py-3 mt-4 rounded-md text-white hover:bg-blue-600 transition-all delay-100 cursor-pointer">
      Submit
    </button>

  </div>
}

const AnnouncementMessage = () => {
  const [currentTab, setCurrentTab] = useState("0");
  const [loading, setLoading] = useState()
  const [announcements, setAnnouncements] = useState([])

  const langs = useLanguages();

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };
  let userToken = localStorage.getItem("userToken");


  const {
    control,
    reset,
    setValue,
    handleSubmit
  } = useForm({
    defaultValues: {
      data: []
    }
  })

  const { fields } = useFieldArray({
    control,
    name: "data"
  });

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  async function getData() {

    if (!langs) return

    setLoading(true);

    await fetch(`${API}/announcement-message`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
    }).then(async (res) => {

      const response = await res.json();

      if (response?.data?.attributes?.data?.length) {
        setAnnouncements(response.data.attributes.data)
        reset({ data: response.data.attributes.data })
      } else {

        const data = langs.map(lan => ({
          title: "",
          content: "",
          isActive: true,
          language: lan.attributes.language
        }))

        setAnnouncements(data)
        reset({ data })
      }

      setLoading(false);
    }).catch(error => {

      toast("Can not fetch announcement message, Please try again", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });

      setLoading(false);
    });
  }


  useEffect(() => {
    getData()
  }, [langs])


  const onSubmitUpdate = async (values, index) => {
    const updatedAnnouncementLanguage = values.data[index]


    const announcementsUpdateBody = announcements.map((announcement, i) => {
      if (index === i) return updatedAnnouncementLanguage
      return announcement
    })

    try {
      const res = await fetch(`${API}/announcement-message`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { data: announcementsUpdateBody },
        }),
      })

      const response = await res.json();

      setAnnouncements(response.data.attributes.data)

      toast("Announcement message Updated Successfully", {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "success",
      });


    } catch (error) {

      toast("Can not update announcement message, Please try again", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });

    }
  }

  return <TabContext value={currentTab}>
    <Box sx={{ width: "100%" }}>
      <h3 style={{ textTransform: "capitalize" }}>Announcement Message</h3>

      <Box mt={2}>
        {/* <ClearCacheButton
          keys={[
            CACHE_KEY.aboutUs
          ]} /> */}
      </Box>

      <Tabs
        value={currentTab}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs"
      >
        {langs?.map((item, index) => {
          return (
            <Tab
              key={index}
              sx={tabStyle}
              value={index.toString()}
              label={item.attributes.language}
              icon={
                <img
                  src={
                    SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                  }
                  style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                />
              }
              iconPosition="start"
            />
          );
        })}
      </Tabs>


      {
        loading
          ? <>...</>
          : fields?.map((field, index) => (
            <TabPanel value={index.toString()} key={field.id}>
              <AnnouncementLanguageForm
                control={control}
                index={index}
                handleSubmit={handleSubmit}
                onSubmit={onSubmitUpdate}
              />
            </TabPanel>
          ))
      }



    </Box>
  </TabContext>
}

export default AnnouncementMessage